import { render, staticRenderFns } from "./replace-wechat-dialog.vue?vue&type=template&id=ba9bba14&"
import script from "./replace-wechat-dialog.vue?vue&type=script&lang=js&"
export * from "./replace-wechat-dialog.vue?vue&type=script&lang=js&"
import style0 from "./replace-wechat-dialog.vue?vue&type=style&index=0&id=ba9bba14&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports